export const base64ToVideo = (base64String, mimeType = "video/mp4") => {
  // Eliminar encabezado si existe (ej. "data:video/mp4;base64,")
  const cleanedBase64 = base64String.replace(/^data:.*;base64,/, "");

  // Convertir Base64 a bytes
  const byteCharacters = atob(cleanedBase64);
  const byteNumbers = new Array(byteCharacters.length)
    .fill()
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  // Crear un Blob de tipo video
  return new Blob([byteArray], { type: mimeType });
};

export const base64ToUint8Array = (base64String) => {
  // quita encabezado data URL y espacios/saltos
  let cleanedBase64 = base64String
    .replace(/^data:.*;base64,/, "")
    .replace(/\s+/g, "");
  // padding si falta
  const pad = cleanedBase64.length % 4;
  if (pad) cleanedBase64 += "=".repeat(4 - pad);

  const byteCharacters = atob(cleanedBase64);
  const byteArray = new Uint8Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }
  return byteArray;
};
